// Using example from Tailwind UI: https://tailwindui.com/components/application-ui/elements/dropdowns
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Image from 'next/image';
import { FaBackward, FaChevronDown, FaCrown, FaFastForward, FaMoneyBill, FaUser, FaUsers } from 'react-icons/fa';
import { BsFillPeopleFill } from 'react-icons/bs';
import { BiSortAlt2 } from 'react-icons/bi';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
};

const currents = [
    {
        icon: FaBackward,
        key: "createdAt:desc",
        full: "Posting date (newest)",
        short: "Newest",
    },
    {
        icon: FaFastForward,
        key: "createdAt:asc",
        full: "Posting date (oldest)",
        short: "Oldest",
    },
    {
        icon: FaMoneyBill,
        key: "pay:desc",
        full: "Salary",
        short: "Salary",
    }
];

export default function CategoryDropdown({ current, onClick }) {
  return (
    <Menu as="div" className="relative inline-block text-left z-50">
      <div>
        <Menu.Button className={`inline-flex items-center flex-row font-BreezeButton gap-x-2 text-xs leading-tight px-4 py-2 ${current !== "createdAt:desc" ? "bg-gray-200" : "bg-gray-400 hover:bg-gray-300"} active:shadow-lg transition-colors duration-500 ease-in-out uppercase text-sp text-black rounded-full`}>
            <>
                <BiSortAlt2 className="w-6 h-4" />
                {currents.find(c => c.key === current)?.short || "Unknown Sort"}
            </>
            <FaChevronDown className="w-3" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute left-0 mt-2 w-56 min-h-[2vh] max-h-[50vh] overflow-y-auto rounded-md shadow-lg bg-slate-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
                {currents.map((s, i) => (
                    <>
                        <Menu.Item key={s?.key || Math.floor(Math.random() * 100) + 1}>
                            {({ active }) => (
                                <button
                                key={s?.key || Math.floor(Math.random() * 100) + 1}
                                onClick={() => onClick(s?.key)}
                                className={`
                                    ${active ? 'bg-gray-600 text-slate-100' : 'text-gray-100'}} 
                                    block px-4 py-2 text-sm flex flex-row gap-x-2 items-center text-left w-full
                                `}
                                >
                                    { s?.icon && <s.icon className="w-6 h-4" /> }
                                    {s?.full}
                                </button>
                            )}
                        </Menu.Item>
                    </>
                ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export { currents };